import type ShouldRenderOffscreen from './types';

const shouldRenderOffscreen: ShouldRenderOffscreen = false;

export default shouldRenderOffscreen;
